import React from "react";
import styled from "styled-components";
import media from "@/styles/mediaQueries";
import noImagesPlaceHolder from "@/images/noImagesPlaceHolder.jpg";
import {IconNoImages} from "@/Icons/IconNoImages";
import { Text } from "@lmn/design-system";

interface ContainerProps {
  $hasMinHeight?: boolean;
}

const NoImagesContainer = styled.div<ContainerProps>(({ theme, $hasMinHeight }) => ({
  gridColumn: "1 / -1",
  gridRow: "1 / -1",
  width: "100%",
  height: "100%",
  borderRadius: theme.kallisto.border.radius.radius200,
  overflow: "hidden",
  position: "relative" as const,
  ...($hasMinHeight && {
    ...media.screenSmMin({
      minHeight: "370px",
    }),
  }),
  img: {
    position: "absolute",
    top: 0, left: 0,
    width: "100%", height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    zIndex: 1,
  },
}));


const OverlayContent = styled.div(({ theme }) => ({
  position: "relative" as const,
  zIndex: 2,
  width: "100%",
  height: "100%",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",

  textAlign: "center",
  color: theme.kallisto.color.text.static.textOnDark,
  padding: theme.kallisto.space.space200,
  backgroundColor: "rgba(0, 0, 0, 0.4)",
}));

const IconCircle = styled.div(({ theme }) => ({
  width: "64px",
  height: "64px",
  borderRadius: "50%",

  backgroundColor: "rgba(255, 255, 255, 0.15)",
  border: "1px solid rgba(255, 255, 255, 0.4)",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.kallisto.space.space200,
}));

export default function NoImagesPlaceHolder({ hasMinHeight = false }) {
  return(
    <NoImagesContainer $hasMinHeight={hasMinHeight}>
      <img
        src={noImagesPlaceHolder.src}
        alt={'Kein Hotelbild verfügbar'}
      />
      <OverlayContent>
        <IconCircle>
          <IconNoImages size={28}/>
        </IconCircle>
        <Text variant="Title4" weight="medium" color="textOnDark">
          Kein Hotelbild verfügbar
        </Text>
        <Text variant="Title6" weight="medium" color="textOnDark">
          Für dieses Hotel sind leider noch keine Bilder vorhanden.
        </Text>
      </OverlayContent>
    </NoImagesContainer>
  )
}
